var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.70211 18.2695C2.48265 18.2695 2.33635 18.1971 2.19005 18.0523C1.9706 17.8351 1.9706 17.6179 2.04375 17.3284L3.14101 13.7084C3.28731 13.1293 3.65307 12.4777 4.16512 12.0433L13.0164 3.13831C13.6016 2.55912 14.3331 2.26953 15.1378 2.26953C15.8693 2.26953 16.6008 2.55912 17.186 3.06591C18.2832 4.15188 18.2832 6.03424 17.1128 7.19261L9.65144 14.6496C9.35883 14.9392 8.91993 14.9392 8.62733 14.6496C8.33472 14.36 8.33472 13.9256 8.62733 13.636L16.0887 6.25143C16.6739 5.67225 16.7471 4.65867 16.1619 4.07949C15.8693 3.78989 15.5035 3.6451 15.1378 3.6451C14.6988 3.6451 14.3331 3.78989 13.9673 4.15188L5.26239 12.8397L7.82267 15.3736C7.96897 15.5184 8.04212 15.7356 8.04212 15.9528C8.04212 16.17 7.89582 16.3872 7.74952 16.4596L7.60321 16.532C7.23746 16.7492 6.87171 16.9664 6.4328 17.1112L2.84841 18.1971C2.77526 18.2695 2.77526 18.2695 2.70211 18.2695ZM4.53088 13.998C4.53088 14.0704 4.53088 14.0704 4.45773 14.1428L3.72622 16.532L6.06705 15.808C6.1402 15.808 6.1402 15.808 6.21335 15.7356L4.53088 13.998Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilWhiteIcon);
export default __webpack_public_path__ + "static/media/pencil-white-icon.f5557f4f9c7dd9bc1852923875622fa6.svg";
export { ForwardRef as ReactComponent };